/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import {ServicoListComponent} from "./servico-list/servico-list.component";
import {ServicoFormComponent} from "./servico-form/servico-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";
import {ServicoBemListComponent} from "./servico-bens/servico-bem-list/servico-bem-list.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ServicosRoutingModule {}

export const servicosRoutes: any[] = [
    {
        path: '',
        component: ServicoListComponent
    },{
        path: editRoute + '/:id',
        component: ServicoFormComponent
    },{
        path: newRoute,
        component: ServicoFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servicos-routing.module.ts
 **/